<template>
  <div :class="containerClass">
    <component
      :is="resolveTag(item)"
      v-for="(item, idx) in items"
      :key="idx"
      :to="resolveRoute(item)"
      :href="resolveHref(item)"
      :class="linkClass"
      :rel="resolveTag(item) === 'a' ? 'noopener noreferrer' : null"
      :target="resolveTag(item) === 'a' ? '_blank' : null"
    >
      <CIcon
        v-if="icon"
        :name="icon"
        size="sm"
        class="ai-citation__icon"
      />
      <span>{{ item.label }}</span>
    </component>
  </div>
</template>

<script>
// Renders a list of `{ label, to }` citations. `to` is either an absolute
// admin-UI path (starts with `/`, mounted as <router-link>) or an external
// URL (mounted as <a target=_blank rel=noopener>). The data comes from the
// worker/LLM stream, so external hrefs go through safeHref.

import { safeHref } from './markdown'

export default {
  name: 'CitationLinks',

  props: {
    items: {
      type: Array,
      default: () => [],
      validator: arr => arr.every(it => it && typeof it.label === 'string' && typeof it.to === 'string')
    },
    containerClass: {
      type: String,
      default: 'ai-citations'
    },
    linkClass: {
      type: String,
      default: 'ai-citation'
    },
    icon: {
      type: String,
      default: ''
    }
  },

  methods: {
    isInternal(item) {
      return Boolean(item && typeof item.to === 'string' && item.to.startsWith('/') && !item.to.startsWith('//'))
    },
    resolveTag(item) {
      return this.isInternal(item) ? 'router-link' : 'a'
    },
    resolveRoute(item) {
      return this.isInternal(item) ? item.to : null
    },
    resolveHref(item) {
      return this.isInternal(item) ? null : (item && item.to ? safeHref(item.to) : null)
    }
  }
}
</script>
